import React, { useContext } from 'react';

import classNames from 'classnames';

import { MDXAST, TOCItem } from '../../../types';
import { ContentContext } from '../../context/ContentContext';
import { useSettingsParams } from '../../hooks/content/useSettingsParams';
import { useActiveTOCHeading } from '../../hooks/useActiveTOCHeading';
import { useHeaderId } from '../../hooks/useHeaderId';
import { useTOCItems } from '../../hooks/useTOCItems';
import { InternalLink } from '../InternalLink';

import * as classes from './style.module.scss';

interface Props {
  imagesLoaded: boolean;
  contentRef: React.MutableRefObject<HTMLDivElement | null>;
  mdxAST: MDXAST;
}

export const TOC: React.FC<Props> = ({ imagesLoaded, contentRef, mdxAST }) => {
  const { activeItems } = useContext(ContentContext);
  const settingsParams = useSettingsParams();
  const items: TOCItem[] = useTOCItems(activeItems, mdxAST);
  const activeHeading = useActiveTOCHeading(imagesLoaded, contentRef, items);

  const [getSlug] = useHeaderId();

  return (
    <ul className={classes.list}>
      {items.map(({ depth, value }) => {
        const [slug, text] = getSlug(value);
        return (
          <li key={slug} className={classes.item}>
            <InternalLink
              to={`${settingsParams}#${slug}`}
              className={classNames(classes.link, {
                [classes.active]: slug === activeHeading,
              })}
              aria-current={slug === activeHeading ? 'page' : undefined}
              style={{ marginLeft: depth <= 2 ? '0.5rem' : '1.5rem' }}
            >
              {text}
            </InternalLink>
          </li>
        );
      })}
    </ul>
  );
};
